import React,{useState, useEffect} from 'react';

const CsrProfileRegular = ({sp}) =>{

    const getServices = item =>{

        let services = ""

        for (let x of item["cats"]){
            services += x + ", "
        }

        return services
    }

    if (!sp) return null

    const positives = sp["sources"].filter(x=>x["rectemp"]>=0)
    const negatives = sp["sources"].filter(x=>x["rectemp"]<0)

    console.log(positives)
    console.log(negatives)

    return(
        <div className="card w-100">
            <div className="card-header" style={{background:"#000000", color:"white", fontWeight: "700", fontFamily:"Futura"}}>
                {sp["servicename"]}
            </div>
            <div className="card-body pl-4">
                <div className="row ml-2 mb-4">
                    <span style={{fontStyle: "italic"}} className ="mr-2">Services: </span>{getServices(sp)}
                </div>
                <div className="row ml-2 mb-4">
                    <span style={{fontStyle: "italic"}}>Contact Info:</span>
                </div>
                {sp["contacturl"].length>=1 &&
                    <div className="row ml-4 mb-2">
                        <a style={{cursor:"pointer", color:"black"}} href={sp["contacturl"]} target="_blank"><i class="fa fa-globe mb-2 mr-2" aria-hidden="true"></i>{sp["contacturl"]}</a>
                    </div>
                }
                {sp["contactemail"].length>=1 &&
                    <div class="row ml-4 mb-2">
                        <i class="fa fa-envelope mb-2 mr-2" aria-hidden="true"></i>{sp["contactemail"]}
                    </div>
                }
                {sp["contacttel"].length>=1 &&
                    <div class="row ml-4 mb-2">
                        <i class="fa fa-phone mb-2 mr-2" aria-hidden="true"></i>{sp["contacttel"]}
                    </div>
                }
                <br/>
                <div class="row ml-2 mb-4">
                    <span style={{fontStyle: "italic"}}>Reviews:</span>
                </div>
                <div class="row">
                    <div class="col-6 px-4">
                        <div class="row ml-2 mb-3">Positive:</div>
                        
                            {
                                positives.map((x,idx)=>(
                                    <div class="row ml-2 mb-2">
                                        <span class="badge badge-pill badge-dark mb-2 mr-2">{x["recyear"]}</span>
                                        <span class="mr-2">{x["recperson"]}</span>
                                        <a href={x["recurl"]} target="_blank" style={{cursor:"pointer", color:"inherit"}}><i class="fa fa-commenting fa-xl" aria-hidden="true" title="Review"></i></a>
                                    </div>
                                ))
                            }
                    </div>
                    <div class="col-6 px-4">
                        <div class="row ml-2 mb-3">Negative:</div>
                        {
                                negatives.map((x,idx)=>(
                                    <div class="row ml-2 mb-2">
                                        <span class="badge badge-pill badge-dark mb-2 mr-2">{x["recyear"]}</span>
                                        <span class="mr-2">{x["recperson"]}</span>
                                        <a href={x["recurl"]} target="_blank" style={{cursor:"pointer", color:"inherit"}}><i class="fa fa-commenting fa-xl" aria-hidden="true" title="Review"></i></a>
                                    </div>
                                ))
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CsrProfileRegular